import React from 'react';
import { shape, string, func, oneOfType, number } from 'prop-types';

// Import components
import { PlayerElements as Player } from 'components/elements';
import { ProfileStyled } from './styles';

const SettingItem = ({ item, onSelect, selected }) => {
	const { value, name } = item;
	const handleItemSelect = () => onSelect(item);

	return (
		<ProfileStyled
			onClick={handleItemSelect}
			profile={value}
			selected={selected}
		>
			<Player.IconTick /> <span>{name}</span>
		</ProfileStyled>
	);
};

SettingItem.propTypes = {
	item: shape({
		value: oneOfType([string, number]).isRequired,
		name: string.isRequired
	}),
	onSelect: func.isRequired,
	selected: oneOfType([string, number]).isRequired
};

export default SettingItem;
